import { baseApi, apiTags } from '../baseApi';
import type { Employee } from '../types/api.types';
import type { LaravelQueryBuilder } from '../types/laravelRequest';

export const hierarchyApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getEmployees: builder.query<Employee[], void>({
            query: () => ({
                resource: 'employee',
                action: 'index',
                method: 'GET',
                queryBuilder: (query: LaravelQueryBuilder) => {
                    return query.whereHas('roles', (rolesQuery: LaravelQueryBuilder) => {
                        rolesQuery.where(
                            'slug',
                            'manager'
                        ).orWhere('slug', 'owner');
                    });
                },
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Employee, id: 'LIST' },
                          ...result.map((item) => ({ type: apiTags.Employee, id: item.id })),
                      ]
                    : [{ type: apiTags.Employee, id: 'LIST' }],
        }),
    }),
});

export const { useGetEmployeesQuery } = hierarchyApi;
